import { isFieldForUserType } from './fieldHelpers';

const SALES_FIELDS = [
  'salesCount',
  'sales_count',
  'salesTotal',
  'sales',
  'soldCount',
  'salesCounter',
  'numSales',
  'completedSales',
];

const parseCount = value => {
  if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
    return parseCount(value.count ?? value.total ?? value.value ?? value.salesCount);
  }
  if (typeof value !== 'number' && typeof value !== 'string') return null;
  if (typeof value === 'string' && value.trim() === '') return null;

  const count = Number(value);
  return Number.isSafeInteger(count) && count >= 0 ? count : null;
};

/**
 * Read a recorded public sales count without substituting reviews or generic transaction totals.
 * Missing or invalid data remains unknown; a recorded zero is a valid count.
 *
 * @param {Object} publicData Public profile data
 * @param {Array<Object>} userFieldConfig Configured profile fields and their visibility
 * @returns {{ count: number|null, fieldKey: string|null }} First visible, valid sales count
 */
export const getRecordedSalesCount = (publicData = {}, userFieldConfig = []) => {
  for (const key of SALES_FIELDS) {
    const fieldConfigs = userFieldConfig.filter(field => field.key === key);
    const canDisplay =
      fieldConfigs.length === 0 ||
      fieldConfigs.some(
        field =>
          field.scope === 'public' &&
          field.showConfig?.displayInProfile !== false &&
          isFieldForUserType(publicData.userType, field)
      );
    if (!canDisplay) continue;

    const count = parseCount(publicData[key]);
    if (count !== null) return { count, fieldKey: key };
  }

  return { count: null, fieldKey: null };
};
